import React, { useState } from "react";
import { Button, ListItem, List, ListItemIcon, Box, Typography, IconButton } from "@material-ui/core";
import { DeleteOutline } from '@material-ui/icons';
import edit from '../assets/icons/secondary-light-black-app-window-edit.png';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import bin from '../assets/icons/primary-blue-bin.png';
import icBlueAdd from '../assets/icons/icBlueAdd.png';
import { useTranslate } from 'react-admin';
import ListItemPopover from '../list-item-popover';
import TableSendItem from './table-sent-item';
import TableDraftItem from './table-draft-item';
import TableScheduledItem from './table-scheduled-item';
import { MESSAGES_TYPE } from '../utils';
import { usePopupState, bindToggle } from "material-ui-popup-state/hooks";

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.palette.text.secondary,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: theme.spacing(1.25),
        paddingBottom: theme.spacing(1.25),
        paddingLeft: 0,
    },
    unread: {
        backgroundColor: theme.palette.grey[200]
    },
    childItem: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    subjectText: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: 14,
        fontWeight: '500',
        color: theme.palette.primary.main,
        letterSpacing: 'normal'
    },
    anotherText: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: 11,
        fontWeight: '500',
        color: '#88898c',
        letterSpacing: "normal",
        lineHeight: '13.2px'

    },
    iconContainer: {
        minWidth: 'unset',
        top: 24,
        right: 16,
        backgroundColor: '#e5f1f8',
        padding:8,
        borderRadius: '12px',
        position: 'absolute',

    },
    icon: {
        width: 16,
        height: 16
    },
    iconPopover: {
        minWidth: 30
    },
    textTab: {
        fontSize: 13,
        color: '#4f5064',
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        letterSpacing: '0.13px',
        lineHeight: '16.3px',
        fontStyle: 'normal',
        fontStretch: 'normal',
        padding: '5px'
    }
}));

function Index({ item, onCheck, onEdit, onDelete, onMarkRead, type, isDelete, isUpdate }) {
    const translate = useTranslate();
    const classes = useStyles();
    const popupState = usePopupState({ variant: 'popper', popupId: 'alarmItemDialog' });
    const showEditButton = type === MESSAGES_TYPE.DRAFT || type === MESSAGES_TYPE.SCHEDULED;

    const onCheckboxClick = e => {
        e.stopPropagation();
        // e.preventDefault();
        onCheck(item.id);
    }

    const onDeleteItemClick = (event) => {
        popupState.close();
        onDelete([item.id]);
        event.stopPropagation()
    }

    const onDoubleClick = () => {
        // TODO: Show detail dialog
        // setShowDetailDialog(true);
        onMarkRead(item.id);
    }

    const onEditItemClick = () => {
        popupState.close();
        onEdit(item.id);
    }

    return (
        <List style={{ paddingTop: 10, paddingBottom: 0 }} onClick={type === MESSAGES_TYPE.DRAFT || type === MESSAGES_TYPE.SCHEDULED?onEditItemClick:onDoubleClick}>
            {type === MESSAGES_TYPE.SENT && <TableSendItem item={item} classes={classes} onCheckboxClick={onCheckboxClick} isDelete={isDelete} />}
            {type === MESSAGES_TYPE.DRAFT && <TableDraftItem item={item} classes={classes} onCheckboxClick={onCheckboxClick} isDelete={isDelete} />}
            {type === MESSAGES_TYPE.SCHEDULED && <TableScheduledItem item={item} classes={classes} onCheckboxClick={onCheckboxClick} isDelete={isDelete} />}
            {isUpdate &&

                <IconButton className={classes.iconContainer} onClick={onDeleteItemClick}>
                    <img alt='' src={bin} width={15} height={15}/>
                </IconButton>
            }
        </List >
    );
}

Index.propTypes = {
    item: PropTypes.object.isRequired,
    onCheck: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onMarkRead: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
};

export default Index;
